module.exports = __webpack_public_path__ + "static/Kollektif-0cc91420e7f6a0d61cc837bc0e467e02.woff";